import {RouteConfig} from 'vue-router';

import Settings from './pages/Settings.vue';
import Accounts from './pages/Accounts.vue';
import Organization from './pages/Organization.vue';
import Locations from './pages/Locations.vue';
import Workplaces from './pages/Workplaces.vue';
import Stations from './pages/Stations.vue';
import Customers from './pages/Customers.vue';
import Defects from './pages/Defects.vue';
import MachineComponents from './pages/MachineComponents.vue';
import Products from './pages/Products.vue';
import ProductCollections from './pages/ProductCollections.vue';
import Materials from './pages/Materials.vue';
import Projects from './pages/Projects.vue';
import Notifications from './pages/Notifications.vue';
import Categories from './pages/Categories.vue';
import Roles from './pages/Roles.vue';
import Groups from './pages/Groups.vue';
import NotRatedOptionReasons from './pages/NotRatedOptionReasons.vue';
import Departments from './pages/Departments.vue';
import Positions from './pages/Positions.vue';
import ShiftTypes from './pages/ShiftTypes.vue';
import ShiftTeamTypes from './pages/ShiftTeamTypes.vue';
import ScrapReasons from './pages/ScrapReasons.vue';
import CycleTimes from './pages/CycleTimes.vue';
import ScrapCauses from './pages/ScrapCauses.vue';
import TenantIpRestrictions from './pages/TenantIpRestrictions.vue';
import Import from './pages/Import.vue';
import AgendaTransfer from './pages/AgendaTransfer.vue';
import WorkplaceShutdowns from './pages/WorkplaceShutdowns.vue';
import Targets from './pages/Targets.vue';
import UnitOfMeasures from './pages/UnitOfMeasures.vue';
import { PermissionTypeEnum } from '../Api';

export default [
    {
        path: '/:tenantId/settings',
        name: 'Settings',
        component: Settings,
        props: (route) => ({tenantId: route.params.tenantId}),
        meta: {
            permissions: [ PermissionTypeEnum.Admin ],
            title: "menu.settings"
        },
        children: [
            {
                path: 'accounts',
                name: 'Accounts',
                component: Accounts,
                meta: {
                    permissions: [ PermissionTypeEnum.Admin ],
                    title: "menu.settings"
                }
            },
            {
                path: 'materials',
                name: 'Materials',
                component: Materials,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'defects',
                name: 'Defects',
                component: Defects,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'machine-components',
                name: 'MachineComponents',
                component: MachineComponents,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'unit-of-measures',
                name: 'UnitOfMeasures',
                component: UnitOfMeasures,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'cycle-times',
                name: 'CycleTimes',
                component: CycleTimes,
                props: (route) => ({ tenantId: route.params.tenantId }),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'organization',
                name: 'Organization',
                component: Organization,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.Admin ],
                    title: "menu.settings"
                }
            },
            {
                path: 'locations',
                name: 'Locations',
                component: Locations,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'workplaces',
                name: 'Workplaces',
                component: Workplaces,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'workplace-shutdowns',
                name: 'WorkplaceShutdowns',
                component: WorkplaceShutdowns,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'targets',
                name: 'Targets',
                component: Targets,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'stations',
                name: 'Stations',
                component: Stations,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'customers',
                name: 'Customers',
                component: Customers,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'products',
                name: 'Products',
                component: Products,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'product-collections',
                name: 'ProductCollections',
                component: ProductCollections,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'notifications',
                name: 'Notifications',
                component: Notifications,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'projects',
                name: 'Projects',
                component: Projects,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/categories',
                name: 'Categories',
                component: Categories,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/roles',
                name: 'Roles',
                component: Roles,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.Admin ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/groups',
                name: 'Groups',
                component: Groups,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/not-rated-option-reasons',
                name: 'NotRatedOptionReasons',
                component: NotRatedOptionReasons,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/departments',
                name: 'Departments',
                component: Departments,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/positions',
                name: 'Positions',
                component: Positions,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/shift-types',
                name: 'ShiftTypes',
                component: ShiftTypes,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/shift-team-types',
                name: 'ShiftTeamTypes',
                component: ShiftTeamTypes,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: '/:tenantId/tenant-ip-restrictions',
                name: 'TenantIpRestrictions',
                component: TenantIpRestrictions,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            },
            {
                path: 'import',
                name: 'Import',
                component: Import,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.Admin, PermissionTypeEnum.Admin ]
                }
            },
            {
                path: '/:tenantId/scrap-reasons',
                name: 'ScrapReasons',
                component: ScrapReasons,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.Admin, PermissionTypeEnum.Admin ]
                }
            },
            {
                path: '/:tenantId/scrap-causes',
                name: 'ScrapCauses',
                component: ScrapCauses,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.Admin, PermissionTypeEnum.Admin ]
                }
            },
            {
                path: '/:tenantId/agenda-transfer',
                name: 'AgendaTransfer',
                component: AgendaTransfer,
                props: (route) => ({tenantId: route.params.tenantId}),
                meta: {
                    permissions: [ PermissionTypeEnum.AdminGroups ],
                    title: "menu.settings"
                }
            }
        ]
    }
] as RouteConfig[];
